import React from 'react'

export default function Contacts() {
    return (
        <div id='contact'>

           
            <form>
            <h1> Order Food(Coming Soon) </h1>

                <input type='text'placeholder='Full Name'/>
                <input type='tel' placeholder='Phone Number '/>
                <input type='tel' placeholder='Home Address '/>
                <input type='tel' placeholder='Restaurant Address '/>
                <textarea placeholder='Additional details'></textarea>
                <input type='submit'value='Order Delivery'/>
            </form>
            
        </div>
    )
}
